import React from 'react';
import { useTranslation } from 'react-i18next';

export default function SoldOutBanner() {
  const { t } = useTranslation();
  return (
    <div>
      <strong>{t('sold_out_new_stock_coming_soon')}</strong>
    </div>
  );
}
